import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from "@chakra-ui/react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { ViewDocumentAsOwnerDto } from "../../autogen/bff-api";
import { NeedAttachmentChoice } from "./NeedAttachmentChoice";

interface Props {
  attachments: ViewDocumentAsOwnerDto[];
  isCreating: boolean;
  onCreate: (attachmentIds: string[]) => Promise<void>;
  onClose: () => void;
}

export const CreateProcurementFromNeedDialog = ({
  attachments,
  isCreating,
  onCreate,
  onClose,
}: Props) => {
  const { t } = useTranslation();
  const [chosen, setChosen] = useState<string[]>([]);
  return (
    <Modal isOpen onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent bg="smModalBackground">
        <ModalHeader>{t("Create procurement")}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Stack spacing="4">
            <Text fontSize="sm" color="smMuted">
              {t(
                "The need's title, description and estimated value come along into the procurement.",
              )}
            </Text>
            <NeedAttachmentChoice
              attachments={attachments}
              chosen={chosen}
              onChange={setChosen}
            />
          </Stack>
        </ModalBody>
        <ModalFooter>
          <Button
            variant="ghost"
            mr="3"
            onClick={onClose}
            isDisabled={isCreating}
          >
            {t("Cancel")}
          </Button>
          <Button
            colorScheme="teal"
            isLoading={isCreating}
            onClick={() =>
              void onCreate(
                chosen.filter((id) =>
                  attachments.some((attachment) => attachment.id === id),
                ),
              )
            }
          >
            {t("Create procurement")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
